// extracted by mini-css-extract-plugin
export default {"Image":"styles_Image__RO+GG","overlay":"styles_overlay__k+meS","mediaLeft":"styles_mediaLeft__Bx6TJ"};